
<section class="pt-4 ">

  <div class="row pb-4">
    <div class="col-12 d-flex justify-content-between px-5">
      <h2 class="text-left text-white px-3 my-4"> Listado de pagos para el proyecto: {{ name }}</h2>

      <div class="d-flex justify-content-center align-items-center">
        <button
        class="badge rounded-pill btn btn-outline-light mt-5 mb-3 mx-2"
        [routerLink]="['/pdg/project/list']"
      >
        <i
          class="fa-solid fa-right-from-bracket m-2 fs-6"
          aria-hidden="true"
        ></i>
        <span class="m-2 fs-6">Volver</span>
      </button>

      <button
        class="badge rounded-pill btn btn-outline-light mt-5 mb-3 mx-2"
        [routerLink]="['/pdg/project/pay/create', idProject,'0', name]"
      >
        <i
          class="fa-solid fa-plus m-2 fs-6"
          aria-hidden="true"
        ></i>
        <span class="m-2 fs-6">Crear pago</span>
      </button>

     

  

    </div>
  </div>


    <div class="container-fluid px-5">
      <div class="backgroundTable">

        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="componente-importantes componente-importantes-from-popup">
          
          <ng-container *ngIf="ListPay.length == 0">">
            <div class="text-center text-white">
              <h2 class="text-white px-5 mt-5">Sin Registro</h2>
              <i class="fa-solid fa-face-sad-cry fa-5x my-3"></i>
            </div>
          </ng-container>

          <ng-container *ngIf="ListPay.length != 0">
          <thead>
            <tr>
              <th class="text-white text-center">Descripcón</th>
              <th class="text-white text-center">F Programada</th>
              <th class="text-white text-center">F Reprogramada</th>
              <th class="text-white text-center">F Real</th>
              <th class="text-white text-center">Estado</th>
              <th class="text-white text-center">Anexo</th>
              <th class="text-white text-center">$</th>
              <th class="text-white text-center">Monto</th>
              <th class="text-white text-center">%</th>
              <th class="text-white text-center">Opciones</th>
          </thead>

          <tbody>
            <tr *ngFor="let item of ListPay">

              <td class="text-center pointer">{{item.title}}</td>
              <td class="text-center pointer">{{item.scheduled_date}}</td>
              <td class="text-center pointer">{{item.rescheduled_date}}</td>
              <td class="text-center pointer">{{item.real_date}}</td>
              <td >
                <div class="p-2 bd-highlight d-flex flex-column">
                  <span *ngIf="item.status === 'REPROGRAMADO'"
                      class="badge rounded-pill text-bg-warning p-2 " style="font-size: 12px;">{{item.status}}</span>
                      <span *ngIf="item.status === 'PAGADO'"
                      class="badge rounded-pill text-bg-success p-2 " style="font-size: 12px;">{{item.status}}</span>
                      <span *ngIf="item.status === 'ANULADO'"
                      class="badge rounded-pill text-bg-danger p-2 " style="font-size: 12px;">{{item.status}}</span>
                      <span *ngIf="item.status === 'PENDIENTE'"
                      class="badge rounded-pill text-bg-info p-2 " style="font-size: 12px;">{{item.status}}</span>
                      <span *ngIf="item.status === 'DESCONTADO'"
                      class="badge rounded-pill text-bg-desc p-2 " style="font-size: 12px;">{{item.status}}</span>
                      <span *ngIf="item.status != 'PENDIENTE' && item.status != 'ANULADO' && item.status != 'PAGADO' && item.status != 'REPROGRAMADO' && item.status != 'DESCONTADO'"
                      class="badge rounded-pill text-bg-default p-2 " style="font-size: 12px;">SIN REGISTRO</span>
                </div>
              </td>


              <td class="text-center">{{item.anexo}}</td>
              <td class="text-center">{{item.money}}</td>
              <td class="text-center">{{item.pay_amount}}</td>
              <td class="text-center">{{item.amount_percent}}%</td>

              
              <td *ngIf="item.status != 'PAGADO' && item.status != 'DESCONTADO'" class="text-center">

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button [routerLink]="['/pdg/project/pay/into', item.id, idProject,name]" ngbDropdownItem>
                      <ng-container *ngIf="!valideNegative(item.pay_amount)">Pagar
                      </ng-container>
                      <ng-container *ngIf="valideNegative(item.pay_amount)">Descontar
                      </ng-container>
                    </button>
                    <button [routerLink]="['/pdg/project/payEdit', item.id, name, idProject]" ngbDropdownItem>Editar</button>
                    <button  [routerLink]="['/pdg/project/pay/reschedule', item.id, idProject,name]" ngbDropdownItem>Reprogramar</button>
                    <button [routerLink]="['/pdg/project/payHistory', item.id, name, idProject]" ngbDropdownItem>Historial</button>
                    <button (click)="stageAnularPay(item.id, item.pay_amount)" ngbDropdownItem>Anular</button>
                    <button (click)="stageDeletePay(item.id, item.pay_amount)" ngbDropdownItem>Eliminar</button>                  </div>
                </div>
              </td>

              <td *ngIf="item.status == 'PAGADO' || item.status == 'DESCONTADO'" class="text-center">

                <div ngbDropdown class="d-inline-block">
                  <i class="fa-solid fa-gear fa-xl" id="dropdownBasic1" ngbDropdownToggle></i>
                  <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                    <button [routerLink]="['/pdg/project/payEdit', item.id, name, idProject]" ngbDropdownItem>Editar</button>
                    <button [routerLink]="['/pdg/project/payHistory', item.id, name, idProject]" ngbDropdownItem>Historial</button>
                    <button (click)="stageCancelPay(item.id, item.pay_amount)" ngbDropdownItem>
                      <ng-container *ngIf="!valideNegative(item.pay_amount)">Cancelar pago
                      </ng-container>
                      <ng-container *ngIf="valideNegative(item.pay_amount)">Cancelar descuento
                      </ng-container>
                    </button>
                    <button (click)="stageDeletePay(item.id, item.pay_amount)" ngbDropdownItem>Eliminar</button>                  
                  </div>
                </div>
              </td>
             
   
            </tbody>
          </ng-container>
            </table>

          </div>
        </div>
      </div>
  </section>
  
  <router-outlet></router-outlet>

